import { useEffect } from 'react';
import { initPresenceForLoggedInUser } from './helpers/ablyPresence';

import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./screens/Login";
import "./App.css";
import SignIn from "./screens/SignIn";
import SignUp from "./screens/SignUp";
import Register from "./screens/Register";
import RegisterEmail from "./screens/RegisterEmail";
import RegisterPhone from "./screens/RegisterPhone";
import Otp from "./screens/Otp";
import FillProfile from "./screens/FillProfile";
import Preferences from "./screens/Preferences";
import Discover from "./screens/Discover";
import Activity from "./screens/Activity";
import Matches from "./screens/Matches";
import Profile from "./screens/Profile";
import UpdateProfile from "./screens/UpdateProfile";
import Chats from "./screens/Chats";
import ChatRoom from "./screens/ChatRoomOld";
import PhotoUpload from "./screens/PhotoUpload";
import ProtectedRoute from "./globals/ProtectedRoute";
import Bio from "./screens/Bio";
import UserProfile from "./screens/UserProfile";
import Premium from "./screens/Premium";
import Likes from "./screens/Likes";
import Liked from "./screens/Liked";
import SuperConnect from "./screens/SuperConnect";
import ContactUs from "./screens/ContactUs";

function App() {

  useEffect(() => {
    const initializePresence = async () => {
      const userData = localStorage.getItem('userSessionData');
      if (userData) {
        try {
          const user = JSON.parse(userData);
          if (user?.id && user?.name) {
            await initPresenceForLoggedInUser(user.id, user.name);
          }
        } catch (e) {
          console.error('Failed to parse user session', e);
        }
      }
    };
    initializePresence();
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Login />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/register" element={<Register />} />
        <Route path="/email-register" element={<RegisterEmail />} />
        <Route path="/phone-register" element={<RegisterPhone />} />
        <Route path="/otp" element={<Otp />} />

        {/* 🔒 Protected routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/fill-profile" element={<FillProfile />} />
          <Route path="/update-profile" element={<UpdateProfile />} />
          <Route path="/preferences" element={<Preferences />} />
          <Route path="/upload-photos" element={<PhotoUpload />} />
          <Route path="/discover" element={<Discover />} />
          <Route path="/likes" element={<Likes />} />
          <Route path="/liked" element={<Liked />} />
          <Route path="/activity" element={<Activity />} />
          <Route path="/matches" element={<Matches />} />
          <Route path="/chats" element={<Chats />} />
          <Route path="/user-profile" element={<UserProfile />} />
          <Route path="/chat" element={<ChatRoom />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/support" element={<ContactUs />} />
          <Route path="/premium" element={<Premium />} />
          <Route path="/super-connect" element={<SuperConnect />} />
          <Route path="/bio" element={<Bio />} />
        </Route>

      </Routes>
    </BrowserRouter>
  );
}

export default App;
